import { createSlice } from "@reduxjs/toolkit"

const actionsBeneficiaryModalState = createSlice({
  name: "actionsBeneficiaryModalState",
  initialState: {
    open: false,
    data: {
      callback: () => {}
    }
  },
  reducers: {
    setActionsBeneficiaryModalOpen: (state, action) => {
      state.open = action.payload
    },
    setActionsBeneficiaryModalData: (state, action) => {
      state.data = action.payload
    }
  }
})

export const {
  setActionsBeneficiaryModalData,
  setActionsBeneficiaryModalOpen
} = actionsBeneficiaryModalState.actions

export default actionsBeneficiaryModalState.reducer
